import { forwardRef } from "react";
import { motion } from "motion/react";
import classNames from "classnames/bind";
import { TopLevelNavigation } from "@header";
import ImageLink from "../../ImageLink/ImageLink";
import LinkList from "../../LinkList/LinkList";

import styles from './DropdownMenu.module.scss';
const cx = classNames.bind(styles);

type DropdownMenuProps = {
  linkGroups?: TopLevelNavigation[number]["linkGroups"];
  onBlur?: (event: React.FocusEvent<HTMLDivElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLDivElement>) => void;
  menuId?: string
};

const ComponentMap: { [key: string]: React.FC } = {
  'image-link': ImageLink,
  'link-list': LinkList,
};

const DropdownMenu = forwardRef<HTMLDivElement, DropdownMenuProps>((props, ref) => {
  const { linkGroups, onBlur, onKeyDown, menuId } = props;
  return (
    <div
      className={cx("dropdown-menu")}
      onBlur={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget as Node)) {
          onBlur?.(event);
        }
      }}
      ref={ref}
      id={menuId}
    >
      <div className={cx("dropdown-menu__content")}>
      {linkGroups?.map((group, index) => {
        const Component = ComponentMap[group.groupType?.[0] || ''];
        return Component ? <Component key={index} {...group} /> : null;
      })}
      </div>
    </div>
  )
});

export default motion.create(DropdownMenu);